var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-popup',{staticClass:"Modal-Choice",class:_vm.nameClass,attrs:{"id":"VxModal","title":_vm.title,"active":_vm.popupActive},on:{"update:active":function($event){_vm.popupActive=$event}}},[_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }